import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { AccessProfile } from '@pages/AccessProfile'
import { AuthCallback } from '@pages/Authentication/AuthCallback'
import { ConsolidatedEntry } from '@pages/ConsolidatedEntry'
import { Consumption } from '@pages/Consumption'
import { Dashboard } from '@pages/Dashboard'
import { Depreciation } from '@pages/Depreciation'
import { OtherExpenses } from '@pages/OtherExpenses'
import { Inventory } from '@pages/Inventory'
import { Invoicing } from '@pages/Invoicing'
import { Layout } from '@components/layout'
import { Notifications } from '@pages/Notifications'
import { People } from '@pages/People'
import { Preview } from '@pages/Preview'
import { PreviewManagement } from '@pages/PreviewManagement'
import { Settings } from '@pages/Settings'
import { Users } from '@pages/Users'
import { RouteGuard } from './RouteGuard'
import { PrivateRoute } from './PrivateRoute'

export const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="auth">
          <Route path="callback" element={<AuthCallback />} />
        </Route>

        <Route path="/" element={<PrivateRoute element={<Layout />} />}>
          {/* <Route path="/" element={<Layout />}> */}
          <Route index element={<Navigate to="/gestao-financeira/faturamento" replace />} />
          <Route path="dashboard" element={<Dashboard />} />

          {/* URL antiga da Gestão da Prévia (antes de virar filha de /previa) — mantém links/favoritos funcionando */}
          <Route
            path="gestao-financeira/gestao-da-previa"
            element={<Navigate to="/gestao-financeira/previa/gestao-da-previa" replace />}
          />

          <Route element={<RouteGuard />}>
            <Route path="gestao-financeira">
              <Route path="previa" element={<Preview />} />
              <Route path="previa/gestao-da-previa" element={<PreviewManagement />} />
              <Route path="lancamento-consolidado" element={<ConsolidatedEntry />} />
              <Route path="faturamento" element={<Invoicing />} />
              <Route path="consumo" element={<Consumption />} />
              <Route path="pessoas" element={<People />} />
              <Route path="depreciacao" element={<Depreciation />} />
              <Route path="despesas-gerais" element={<OtherExpenses />} />
            </Route>

            <Route path="configuracoes">
              <Route path="usuarios" element={<Users />} />
              <Route path="perfil-de-acesso" element={<AccessProfile />} />
              <Route path="configuracoes" element={<Settings />} />
              <Route path="notificacoes" element={<Notifications />} />
            </Route>

            <Route path="inventario" element={<Inventory />} />
          </Route>

          <Route path="*" element={<Navigate to="/gestao-financeira/faturamento" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
